import { HttpInterceptorFn } from '@angular/common/http';

export const CorrelationIdInterceptor: HttpInterceptorFn = (req, next) => {
    const correlationId = crypto.randomUUID();
    const clonedReq = req.clone({
        headers: req.headers.set('X-Correlation-Id', correlationId),
    });
    return next(clonedReq);
};
